<div class="formly-field-wrap">
  @if(!isDisabled()) {
    <div class="boolean-filter-buttons">
      <ion-button
        [fill]="value === true ? 'solid' : 'outline'"
        [color]="value === true ? 'success' : 'medium'"
        size="small"
        (click)="setBooleanState(true)">
        <app-dynamic-icon class="large-icon" name="checkmark" slot="icon-only"></app-dynamic-icon>
        <span class="btn-label">{{ 'COMMON.TRUE' | translate }}</span>
      </ion-button>
      <ion-button
        [fill]="value === false ? 'solid' : 'outline'"
        [color]="value === false ? 'danger' : 'medium'"
        size="small"
        (click)="setBooleanState(false)">
        <app-dynamic-icon class="large-icon" name="close" slot="icon-only"></app-dynamic-icon>
        <span class="btn-label">{{ 'COMMON.FALSE' | translate }}</span>
      </ion-button>
      @if(!isRequired()) {
        <ion-button
          [fill]="value === null ? 'solid' : 'outline'"
          [color]="value === null ? 'primary' : 'medium'"
          size="small"
          class="empty-btn"
          (click)="setBooleanState(null)">
          <!-- <app-dynamic-icon class="large-icon" name="fa-solid fa-border-none" slot="icon-only"></app-dynamic-icon> -->
          <span class="btn-label">{{ 'COMMON.EMPTY' | translate }}</span>
        </ion-button>
      }
    </div>
  } @else {
    <div class="disabled-input" [class.non-compact]="!options.formState.showCompactViewWhenDisabled">
      @if(options.formState.showCompactViewWhenDisabled) {
        <i [class]="'large-icon ' + getIconClass() + ' ' + getIcon()"></i>
      }
      <span class="text">{{getText() | translate}}</span>
    </div>
  }
  <ng-template #fieldComponent></ng-template>
</div>